import { render, staticRenderFns } from "./multiple-privitive-input.vue?vue&type=template&id=53264c6e&lang=pug&"
import script from "./multiple-privitive-input.vue?vue&type=script&lang=ts&"
export * from "./multiple-privitive-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports